import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { HtmlUtilsService } from "../../../html-utils/html-utils.service";
import { HttpClient } from "@angular/common/http";
import { CoverService } from "./cover.service";
import { catchError, map } from "rxjs/internal/operators";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { BehaviorSubject } from "rxjs";

@Component({
  selector: "app-cover",
  templateUrl: "./cover.component.html",
  styleUrls: ["./cover.component.scss"],
})
export class CoverComponent implements OnInit, OnDestroy, OnChanges {
  private _src: any;
  private _wcgaSrc: any;
  private _alt: string;
  private _bottomText: string;
  private _bottomTextClass: string;
  private _title: string;
  public shouldLoad: BehaviorSubject<boolean>;
  @Input() type: string;
  @Input() id: string;
  @Input() isbn: any;
  @Input() imageAuthor: string;
  bottomTextDisplay: boolean = true;
  highContrast: boolean = false;
  loaded: boolean = false;
  imgSrc: SafeUrl;
  imgClass: string;
  defaultImage = true;
  showAuthorTooltip = false;

  constructor(
    private htmlUtils: HtmlUtilsService,
    private http: HttpClient,
    public coverService: CoverService,
    private santanizer: DomSanitizer
  ) {
    this.shouldLoad = new BehaviorSubject<boolean>(false);
    this.highContrast = this.htmlUtils.contrast;
    this.htmlUtils.highContrast.subscribe((value) => {
      if (value !== this.highContrast) {
        this.highContrast = value;
        this.defaultImg();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.id && !changes.id.firstChange) {
      this.subscribeToLoad();
    }
  }

  ngOnInit() {
    this.defaultImg();
    this.subscribeToLoad();
  }

  ngOnDestroy(): void {
    this.shouldLoad.unsubscribe();
  }

  ngAfterContentInit() {
    this.loaded = true;
  }

  private defaultImg() {
    this.imgSrc = this.highContrast ? this._wcgaSrc : this._src;
    this.imgClass = this.highContrast ? "wcga-vis border-wis" : "normal-vis";
  }

  apiImg(isbn): void {
    if (this.type && this.id && isbn) {
      this.coverService.getCover(this.type, this.id, isbn).subscribe(
        (value) => {
          if (value !== null) {
            let image = new Blob([value], { type: "image/jpeg" });
            const imgSrcLink = window.URL.createObjectURL(image);
            this._src = this.santanizer.bypassSecurityTrustUrl(imgSrcLink);
            this._wcgaSrc = this._src;
            this.bottomTextDisplay = true;
            this.defaultImage = false;
          } else {
            if (!this.highContrast) {
              this._src = this.imgSrc;
            } else {
              this._wcgaSrc = this.imgSrc;
            }
          }
        },
        (error) => {
          this._src = this.imgSrc;
          // console.error(error);
        }
      );
    }
  }

  subscribeToLoad() {
    this.shouldLoad.asObservable().subscribe((value) => {
      if (
        value &&
        this.type &&
        (this.type === "work" || "materialization") &&
        this.isbn.length > 0
      ) {
        this.apiImg(this.isbn);
      }
    });
  }

  @Input()
  set src(value: string) {
    this._src = this.santanizer.bypassSecurityTrustUrl(value);
  }

  @Input()
  set wcgaSrc(value: string) {
    this._wcgaSrc = value;
  }

  @Input()
  set alt(value: string) {
    this._alt = value;
  }

  @Input()
  set bottomText(value: string) {
    this._bottomText = value;
  }

  @Input()
  set bottomTextClass(value: string) {
    this._bottomTextClass = value;
  }

  @Input()
  set title(value: string) {
    this._title = value;
  }

  get src(): string {
    return this._src;
  }

  get wcgaSrc(): string {
    return this._wcgaSrc;
  }

  get alt(): string {
    return this._alt;
  }

  get bottomText(): string {
    return this._bottomText;
  }

  get bottomTextClass(): string {
    return this._bottomTextClass;
  }

  get title(): string {
    return this._title;
  }
}
